import { motion } from "framer-motion";
import { Chapter, Reveal, EASE } from "@/components/motion";
import { STATES } from "@/data/site";

export default function Expansion() {
  return (
    <section className="relative overflow-hidden bg-charcoal py-28 lg:py-36" data-testid="expansion-section">
      <div className="pointer-events-none absolute -bottom-10 left-0 right-0 select-none overflow-hidden">
        <p className="text-outline whitespace-nowrap text-center font-heading text-[16vw] font-extrabold leading-none tracking-tight">
          NATIONWIDE
        </p>
      </div>
      <div className="relative z-10 mx-auto max-w-7xl px-6">
        <Chapter index="07" label="National Expansion" dark />
        <Reveal delay={0.1}>
          <h2 className="mt-8 font-heading text-4xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl">
            From NSW <span className="text-gold">to Australia</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/65">
            Formcore's success in New South Wales has created the foundation for our next stage of growth — establishing
            Formcore as a trusted national workforce partner for Australia's construction industry.
          </p>
        </Reveal>

        <div className="mt-16 hidden h-px w-full bg-white/15 lg:block">
          <motion.div
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1.6, ease: EASE }}
            className="h-px origin-left bg-gold"
          />
        </div>

        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:mt-0 lg:grid-cols-5">
          {STATES.map((state, i) => (
            <Reveal key={state.code} delay={0.15 + i * 0.1} className="h-full">
              <div
                className="group relative h-full border border-white/10 bg-white/[0.03] p-6 transition-colors duration-300 hover:border-gold/60 lg:-mt-px lg:border-t-0 lg:pt-8"
                data-testid={`state-card-${state.code.toLowerCase()}`}
              >
                <span className="absolute -top-2 left-6 hidden h-4 w-4 rotate-45 border border-gold bg-charcoal lg:block" />
                <p className="font-heading text-4xl font-extrabold tracking-tight text-white transition-colors duration-300 group-hover:text-gold">
                  {state.code}
                </p>
                <p className="mt-3 inline-block bg-gold/15 px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.2em] text-gold">
                  {state.status}
                </p>
                <p className="mt-4 text-[13px] leading-relaxed text-white/55">{state.note}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.3}>
          <p className="mt-16 font-heading text-lg font-bold text-white/80">
            Growing with our clients<span className="text-gold">.</span>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
